<template>
  <div class="cascader">
    <el-cascader ref="cascaderAddr" v-if="isShowAddressInfo " :props="props" @change="handleChange" placeholder="省/市/区/街道" v-model="value" clearable></el-cascader>
    <div class="else_cas" v-else>省/市/区/街道</div>
  </div>
</template>

<script>
export default {
  name: "cascaderCity",
  props: {
    isLevel: {
      type: Boolean,
      default: false,
    },
    GetProList: {
      type: Function,
      default: () => {},
    },
    GetDisList: {
      type: Function,
      default: () => {},
    },
    GetTownList: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    let _that = this;
    return {
      value: [],
      props: {
        lazy: true,
        async lazyLoad(node, resolve) {
          //   console.log(node, node.level);
          const { level } = node;
          switch (level) {
            case 0:
              await _that.getProList();
              let nodes1 = _that.proList.map((v) => {
                return {
                  value: v.code,
                  label: v.name,
                  leaf: false,
                };
              });
              resolve(nodes1);
              break;
            case 1:
              let nodes2 = [];
              _that.proList.forEach((v) => {
                if (v.code === node.value) {
                  nodes2 = v.children;
                }
              });
              nodes2 = nodes2.map((v) => {
                return {
                  value: v.code,
                  label: v.name,
                  leaf: false,
                };
              });
              resolve(nodes2);
              break;
            case 2:
              await _that.getDisList(node.value);
              let nodes3 = _that.disList.map((v) => {
                return {
                  value: v.code,
                  label: v.name,
                  leaf: _that.isLevel,
                };
              });
              resolve(nodes3);
              break;
            case 3:
              await _that.getTownList(node.value);
              let nodes4 = _that.townList.map((v) => {
                return {
                  value: v.id,
                  label: v.name,
                  leaf: true,
                };
              });
              resolve(nodes4);
              break;

            default:
              break;
          }
        },
      },
      proList: [],
      disList: [],
      townList: [],
      isShowAddressInfo: true,
    };
  },
  methods: {
    //   选中节点变化时
    handleChange(value) {
      let label = [];
      if (this.$refs.cascaderAddr.getCheckedNodes().length > 0) {
        label = this.$refs.cascaderAddr.getCheckedNodes()[0].pathLabels;
      }
      this.$emit("getEndPlace", { value, label });
    },
    getProList() {
      return this.GetProList({}).then((res) => {
        // console.log(22,"获取省市数据", res);
        this.proList = res.data;
      });
    },
    getDisList(code) {
      let params = {
        cityCode: code,
      };
      return this.GetDisList(params).then((res) => {
        // console.log("获取区数据", res);
        this.disList = res.data;
      });
    },
    getTownList(code) {
      let params = {
        districtCode: code,
      };
      return this.GetTownList(params).then((res) => {
        // console.log("获取街道数据", res);
        this.townList = res.data;
      });
    },
    setValue(val) {
      //   console.log(val);
      //   为了解决数据重填成功问题
      this.value = val;
      this.isShowAddressInfo = false;
      setTimeout(() => {
        this.isShowAddressInfo = true;
      }, 100);
    },
  },
};
</script>

<style lang="less" scoped>
.cascader {
  font-size: 12px;
  .el-cascader {
    min-width: 420px;
    width: 100%;
    line-height: 24px;
    /deep/ .el-input__icon {
      line-height: 24px;
    }
  }
  .else_cas {
    width: 420px;
    height: 24px;
    box-sizing: border-box;
    line-height: 22px;
    border: 1px solid #c0c4cc;
    padding-left: 15px;
    color: #c0c4cc;
    font-size: 14px;
  }
}
</style>